<template>
  <div :id="componentId+'-plot_area'" class="row">
  </div>
</template>


<script>
/* eslint-disable */
import * as d3 from "d3";
import {loadingCircle} from "../mixins/D3Mixin.js"


export default {
  name: "ScatterPlotWidget",
  props: ["axisLabel", "plotData", "componentId", "advanced"],
  mixins: [loadingCircle],

  data() {
    return {
      divId: this.componentId + '-plot_area'
    }
  },

  watch: {
    axisLabel: function () {
      this.drawScatterPlot()
    },
    plotData: function () {
      this.drawScatterPlot()
    },
  },

  mounted() {
    this.initSvg();
  },


  methods: {

    initSvg() {
      this.divElement = document.getElementById(this.divId)
      this.drawScatterPlot()
    },

    drawScatterPlot() {
      if (this.divElement.childNodes.length > 0) {
        while (this.divElement.firstChild) {
          this.divElement.removeChild(this.divElement.lastChild);
        }
      }
      const margin = {top: 20, right: 20, bottom: 40, left: 40},
          width = 350 - margin.left - margin.right,
          height = 208 - margin.top - margin.bottom;

      if (this.plotData === null) {
        this.spinningCircle(margin, width, height)
      } else {
        if (this.plotData.data.length !== 0) {
          let cssCol = "col-12"
          let legend = false
          let svg_numbers = this.plotData.data.length
          if (this.plotData.data.length >= 2) {
            cssCol = "col-6"
          }
          if (this.advanced === "checked") {
            legend = true
          }
          let divElement = this.divElement
          let plotDataDomainXmin = this.plotData.domain.xmin
          let plotDataDomainXmax = this.plotData.domain.xmax
          let plotDataDomainYmin = this.plotData.domain.ymin
          let plotDataDomainYmax = this.plotData.domain.ymax
          let axisLabel = this.axisLabel
          this.plotData.data.forEach(function (split, index) {
            let svg = d3.select(divElement)
                .append("svg")
                .attr("class", cssCol)
                .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
                .append("g")
                .attr("transform",
                    `translate(${margin.left}, ${margin.top})`);


            let x = d3.scaleLinear()
                .range([0, width]);

            // Add Y axis
            let y = d3.scaleLinear()
                .range([height, 0]);


            let xDomain = [plotDataDomainXmin, plotDataDomainXmax];
            x.domain(xDomain);
            y.domain([plotDataDomainYmin, plotDataDomainYmax]);


            let yAxis = svg.append("g")

                .call(d3.axisLeft(y));
            let xAxis = svg.append("g")
                .attr("transform", "translate(0," + height + ")")
                .call(d3.axisBottom(x));
            // Add a clipPath: everything out of this area won't be drawn.
            let clip = svg.append("defs").append("svg:clipPath")
                .attr("id", "clip1")
                .append("svg:rect")
                .attr("width", width)
                .attr("height", height)
                .attr("x", 0)
                .attr("y", 0)
                .attr('fill', 'pink');


            // Color scale: give me a specie name, I return a color
            let div = d3.select("body").append("div")
                .attr("class", "tooltip")
                .style("opacity", 0.5);


            // Add brushing
            let brush = d3.brushX()                 // Add the brush feature using the d3.brush function
                .extent([[0, 0], [width, height]]) // initialise the brush area: start at 0,0 and finishes at width,height: it means I select the whole graph area
                .on("end", updateChart) // Each time the brush selection changes, trigger the 'updateChart' function

            // Create the scatter variable: where both the circles and the brush take place
            let scatter = svg.append('g')
                .attr("clip-path", "url(#clip1)")

            function make_x_gridlines() {
              return d3.axisBottom(x)
                  .ticks(12)
            }

            // gridlines in y axis function
            function make_y_gridlines() {
              return d3.axisLeft(y)
                  .ticks(4)
            }


            let me = this

            scatter
                .append("g")
                .attr("class", "brush")
                .call(brush);
            // Add circles
            scatter
                .selectAll("circle")
                .data(split.values)
                .enter()
                .append("circle")
                .attr("cx", function (d) {
                  return x(d.paramvalue);
                })
                .attr("cy", function (d) {
                  return y(d.abundance);
                })
                .attr("r", 5)
                .style("fill", "#440154ff")
                .style("opacity", 0.5)
                .on("mouseover", function (event, d) {
                  div.transition()
                      .duration(200)
                      .style("opacity", 0.9);
                  div.html(d.abundance.toFixed(3) + " %<br>" + d.paramvalue + " " + axisLabel)
                      .style("background-color", '#005B60')
                      .style("color", 'white')
                      .style("border", "3px")
                      .style("left", (event.pageX) + "px")
                      .style("top", (event.pageY - 50) + "px");
                })
                .on("mouseout", function (d) {
                  div.transition()
                      .duration(500)
                      .style("opacity", 0);
                });


            scatter.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + height + ")")
                .attr("stroke", "currentColor")
                .attr("stroke-opacity", 0.1)
                .call(make_x_gridlines()
                    .tickSize(-height)
                    .tickFormat("")
                )

            scatter.append("g")
                .attr("class", "grid")
                .attr("stroke", "currentColor")
                .attr("stroke-opacity", 0.1)
                .call(make_y_gridlines()
                    .tickSize(-width)
                    .tickFormat("")
                )


            svg.append("text")
                .attr("text-anchor", "end")
                .attr("x", width)
                .attr("y", height + margin.top + 10)
                .style("font-size", "50%")
                .style("font-family", "Avenir, Helvetica, Arial, sans-serif")
                .text(axisLabel);

            svg.append("text")
                .attr("text-anchor", "end")
                .attr("transform", "rotate(-90)")
                .attr("y", -margin.left + 16)
                .attr("x", -margin.top)
                .style("font-size", "70%")
                .style("font-family", "Avenir, Helvetica, Arial, sans-serif")
                .text("%")

            if (legend) {
              svg.append("text")
                  .attr('x', width / 2 - 15)
                  .attr('y', function (d, i) {
                    return (i * 12) + height + 30;
                  })
                  .text(split.group)
                  .attr('text-anchor', 'start')
                  .style("font-size", "15px")
                  .attr("alignment-baseline", "middle")
            }

            // A function that set idleTimeOut to null
            let idleTimeout

            function idled() {
              idleTimeout = null;
            }

            // A function that update the chart for given boundaries
            function updateChart(event) {

              let extent = event.selection
              // If no selection, back to initial coordinate. Otherwise, update X axis domain
              if (!extent) {
                if (!idleTimeout) return idleTimeout = setTimeout(idled, 350); // This allows to wait a little bit
                x.domain(xDomain);
              } else {
                x.domain([x.invert(extent[0]), x.invert(extent[1])])
                scatter.select(".brush").call(brush.move, null) // This remove the grey brush area as soon as the selection has been done
              }

              // Update axis and circle position
              xAxis.transition().duration(1000).call(d3.axisBottom(x))
              scatter
                  .selectAll("circle")
                  .transition().duration(1000)
                  .attr("cx", function (d) {
                    return x(d.paramvalue);
                  })
                  .attr("cy", function (d) {
                    return y(d.abundance);
                  })

            }

          })
        } else {
          this.notEnoughData(margin, width, height)
        }
      }
    }
  }
}

</script>

<style scoped>
</style>